<template>
<div>

  <p v-if="loading">
    {{ $t('loading')}}...
  </p>

  <div v-else-if="error">
      <Error :message="error"/>
  </div>

  <div v-else>

    <NoData v-if="!hasData" />

    <h3 v-if="hasData">
      {{ $tc('campaigns.header',2) }}
    </h3>

    <div class="campaigns-container" v-if="hasData">
      <div class="campaigns">

        <div class="campaigns-header hidden-xs">
          <div class="header flex-2">{{ $t('campaigns.name') }}</div>
          <div class="header flex-2 text-right">{{ $t('campaigns.status') }}</div>
          <div class="header text-right flex-2">{{ $t('campaigns.duration') }}</div>
          <div class="header text-right">{{ $t('campaigns.vehicles') }}</div>
          <div class="header text-right">{{ $t('campaigns.impressions') }}</div>
          <div class="header text-right">{{ $t('campaigns.created') }}</div>
          <div class="header flex-2">{{ $t('campaigns.progress') }}</div>
          <div class="header text-right">{{ $t('campaigns.action') }}</div>
        </div>

        <campaignItem
          v-for="campaign in campaigns"
          :campaign='campaign'
          :key="campaign.id" />

        <div class="campaigns-footer">
          <div>
            <div :class="{'enabled': page > 1}" @click='prevPage()'><i class="fa fa-chevron-left" aria-hidden="true" ></i></div>
            <div :class="{'enabled': page < last_page}" @click='nextPage()'><i class="fa fa-chevron-right" aria-hidden="true" ></i></div>
          </div>
        </div>

      </div>

    </div>

  </div>

</div>
</template>

<script>
import campaignItem from './CampaignItem'
import NoData from './NoData.vue'
import Error from './common/Error.vue'
import api from '../api'

export default {
  name: 'Campaigns',
  components: {
    campaignItem,
    NoData,
    Error
  },
  data () {
    return {
      campaigns: [],
      loading: false,
      error: false,
      hasData: true,
      page: 1,
      last_page: 1
    }
  },
  created () {
    this.getCampaignsList()
  },
  methods: {
    getCampaignsList () {
      var self = this
      self.loading = true
      self.$Progress.set(25)
      api.getCampaigns({'page': self.page})
        .then(
          (r) => {
            self.campaigns = r.data.data
            self.$Progress.finish()
            self.loading = false
            self.hasData = r.data.data.length > 0
            self.last_page = r.data.meta.last_page
          })
        .catch(
          (e) => {
            self.loading = false
            self.$Progress.fail()
            self.error = e.response.data.error
          }
        )
    },
    nextPage () {
      if (this.page < this.last_page) {
        this.page += 1
      }
    },
    prevPage () {
      if (this.page > 1) {
        this.page -= 1
      }
    }
  },
  watch: {
    page () {
      this.getCampaignsList()
    }
  }
}
</script>

<style scoped lang="stylus" src="../styles/_Campaigns.styl"/>



// WEBPACK FOOTER //
// src/components/Campaigns.vue